const account = {
  state: {
    status: ''
  },

  mutations: {
    SET_STATUS: (state, value) => {
      window.localStorage.setItem('cloud_s', value);
    },
    GET_STATUS: (state) => {
      state.status = window.localStorage.getItem('cloud_s');
    },
    REMOVE_STATUS: (state) => {
      window.localStorage.removeItem('cloud_s');
    }
  },

  actions: {
    
  }
}

export default account



// WEBPACK FOOTER //
// ./src/store/modules/account.js